import MobileSiteNavMenu from '../../../../../../shared/frontend/scripts/sidebar/mobileSiteNavMenu';
import { RouteComponentProps } from '../../../../../../shared/common/types/common';
import { getMenuItems } from '../presentational/menuItems';
import QueueButton from '../presentational/queueButton';

// Game-specific props interface
interface TGameSiteNavMenuProps extends RouteComponentProps<any, any> {
  isMenuToggled: boolean;
  setMenuToggled: (toggled: boolean) => void;
}

// Main component that uses the shared MobileSiteNavMenu
function GameMobileSiteNavMenu(props: TGameSiteNavMenuProps) {
  return (
    <MobileSiteNavMenu
      getMenuItems={getMenuItems}
      QueueButton={QueueButton}
      setMenuToggled={props.setMenuToggled}
      isMenuToggled={props.isMenuToggled}
    />
  );
}

export default GameMobileSiteNavMenu;
